import { CompaniesPage } from 'features/public-companies/CompaniesPage';
import { GetStaticProps } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { ServiceStrapi } from 'services/service.strapi';
import { config } from 'utils/config';

export default CompaniesPage;

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  const [
    {
      data: {
        attributes: { text: bannerText }
      }
    },

    { data: testimonials }
  ] = await Promise.all([
    ServiceStrapi.get(`/talent-web-banner?locale=${locale}`),
    ServiceStrapi.get(
      `/companies-page-reviews?populate=%2A&pagination[pageSize]=100&locale=${locale}`
    )
  ]);

  return {
    props: {
      ...(await serverSideTranslations(locale || '', [
        'common',
        'topbar',
        'footer',
        'companies-new'
      ])),

      baseUrl: config.appUrl,
      bannerText: bannerText || '',
      testimonials: testimonials || []
    },
    revalidate: 30
  };
};
